module.exports = __webpack_public_path__ + "common/icon-cart-white-d520d5d20a6b80a5936817a027ad2cfd.svg";